import { TOOL_COUNT, WIDGET_COUNT } from '../data/tools';

const STATS: Array<{ value: string; label: string }> = [
    { value: String(TOOL_COUNT), label: 'Tools' },
    { value: String(WIDGET_COUNT), label: 'Inline widgets' },
    { value: '2', label: 'Transports · HTTP & SSE' },
    { value: '2.1', label: 'OAuth · PKCE' }
];

export function StatsStrip() {
    return (
        <section className="tkh-strip" aria-label="At a glance" data-reveal>
            <div className="tkh-wrap">
                {STATS.map((s, i) => (
                    <div className="tkh-flap" key={s.label}>
                        <span className="val" style={{ '--i': i } as React.CSSProperties}>
                            {s.value}
                        </span>
                        <span className="lbl">{s.label}</span>
                    </div>
                ))}
            </div>
        </section>
    );
}
